import { takeEvery, take, put } from 'redux-saga/effects'

import getRandomness from 'shared/random-generator'

import { GET_ONSTREET_LOCATIONS } from 'on-street/constants'
import { queryPosts } from 'wordpress/actions'
import { POSTS_RECEIVED } from 'wordpress/constants'

import { setOnstreetLocations } from 'on-street/actions'

export default function* rootSaga() {
    yield takeEvery(GET_ONSTREET_LOCATIONS, function* () {
        const requestId = getRandomness()
        yield put(queryPosts('locations', undefined, requestId))

        const { result } = yield take(action => action.type === POSTS_RECEIVED && action.requestId === requestId)
        yield put(setOnstreetLocations(result.posts))
    })
}
